<template>
  <iButton
    v-if="!active"
    key="menu-active"
    type="text"
    shape="circle"
    size="large"
    icon="android-more-vertical"
    @mouseenter.native="onHover()"
  />
  <iDropdown
    v-else
    key="menu-active"
    placement="bottom-end"
    transfer
    @on-click="onClick"
  >
    <iButton
      type="text"
      shape="circle"
      size="large"
      icon="android-more-vertical"/>
    <iDropdownMenu
      slot="list"
    >
      <iDropdownItem name="show">Voir</iDropdownItem>
      <iDropdownItem
        v-if="editable"
        name="edit">Modifier</iDropdownItem>
      <template v-if="deletable">
        <iDropdownItem
          v-show="!row.deletedAt"
          name="delete">Supprimer</iDropdownItem>
        <iDropdownItem
          v-show="row.deletedAt"
          name="restore">Restaurer</iDropdownItem>
      </template>

    </iDropdownMenu>
  </iDropdown>
</template>

<script>
export default {
  name: 'GdlDataTableRowMenu',
  props: {
    row: { type: Object, required: true },
    editable: { type: Boolean, default: true },
    deletable: { type: Boolean, default: true },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onHover() {
      this.active = true;
    },
    onClick(name) {
      this.$emit('selected', { action: name, selected: this.row });
    },
  },
};
</script>

<style scoped>
</style>
